export { default } from './BaseDialog.component'
